import script from "./TheConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./TheConfirmModal.vue?vue&type=style&index=0&id=973adf14&lang=sass"

const __exports__ = script;

export default __exports__